<template>
  <div>
    <div class="row">
      <div v-for="(card,index) in cards" :key="card.title">
        <div :class="{lightgrey: index % 2 === 0}" class="col s12">
          <div class="col s12 m10 l8 offset-m1 offset-l2">
            <h2 class="header">{{$t(card.title)}}</h2>
            <div class="card horizontal">
              <div class="card-image">
                <img :src="card.img.link" :alt="$t(card.img.alt)"/>
              </div>
              <div class="card-stacked">
                <div class="card-content">
                  <p v-html="$t(card.desc)"></p>
                </div>
                <div class="card-action" :class="{hide: card.action === '' }"><p v-html="$t(card.action)"></p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Php',
    data () {
      return {
        cards: [{
          title: 'php.beerable.title',
          img: {link: 'static/img/symfony.png', alt: 'php.beerable.alt.pict'},
          desc: 'php.beerable.desc',
          action: 'php.beerable.action'
        }, {
          title: 'php.tw.title',
          img: {link: 'static/img/twSite.jpg', alt: 'php.tw.alt.pict'},
          desc: 'php.tw.desc',
          action: 'php.tw.action'
        }, {
          title: 'php.krav.title',
          img: {link: 'static/img/site_krav_maga.png', alt: ''},
          desc: 'php.krav.desc',
          action: 'php.krav.action'
        }]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Php.vue